import { render, staticRenderFns } from "./POSCreate.vue?vue&type=template&id=2e314972&scoped=true"
import script from "./POSCreate.vue?vue&type=script&lang=js"
export * from "./POSCreate.vue?vue&type=script&lang=js"
import style0 from "./POSCreate.vue?vue&type=style&index=0&id=2e314972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e314972",
  null
  
)

export default component.exports